module.exports = __webpack_public_path__ + "img/google-pay.bff47746.png";